import React from 'react';
import classnames from 'classnames';
import { Stack } from '@servicetitan/design-system';
import { VisitAssistantSidebarComponentProps } from './visit-assistant-sidebar';
import { VisitAssistantSidebarButtonDesktop } from '../visit-assistant-sidebar-button/visit-assistant-sidebar-button-desktop';
import styles from './visit-assistant-sidebar-desktop.less';
import sidebarStyles from './visit-assistant-sidebar.less';

export const VisitAssistantSidebarDesktop: React.FC<VisitAssistantSidebarComponentProps> = (
    props
) => {
    const { estimateLink, payInvoiceLink } = props;
    return (
        <Stack
            wrap="nowrap"
            alignItems="flex-start"
            className={classnames(styles.container, 'p-x-3 p-b-3')}
            direction="column"
        >
            <div className={classnames(styles.quickLinksTitle, 'm-t-3 m-b-2')}>Quick Links</div>
            {!!estimateLink && (
                <VisitAssistantSidebarButtonDesktop
                    backgroundImageClassName={sidebarStyles.backgroundImageEstimates}
                    title="View Estimates"
                    link={estimateLink}
                />
            )}
            {!!payInvoiceLink && (
                <VisitAssistantSidebarButtonDesktop
                    backgroundImageClassName={sidebarStyles.backgroundImagePayInvoice}
                    title="Pay Invoice"
                    link={payInvoiceLink}
                />
            )}
        </Stack>
    );
};
